import { isMobile } from 'mobile-device-detect';

export const isAuthenticated = state => {
    return state.accessToken !== null
}

export const getAccessToken = state => {
    return state.accessToken
}

export const getAccessibleMenu = state => {
    return state.accessibleModules
}

export const getAllMenus = state => {
    let returnArray = []

    state.accessibleModules.forEach(element => {
        element.sub_menu.forEach(subMenu => {
            returnArray.push(subMenu)
            if(subMenu.has_sub_menu) {
                if(subMenu.sub_sub_menu) {
                    subMenu.sub_sub_menu.forEach(subSubMenu => {
                        returnArray.push(subSubMenu)
                    })
                }                
            }            
        })
    })

    return returnArray
}

export const getDefaultPageLimit = state => {
    return state.default_page_limit
}

export const getAccessibleStoreList = state => {
    return state.store_list
}

export const isTrialMasterAccount = state => {
    return state.trial_account
}

export const isEPaymentEnabled = state => {
    return state.enable_e_payment
}

export const getEncryptedKey = state => {
    return state.encrypted_key
}

export const getLoadingState = state => {
    return state.loadingState
}

export const getMachineId = state => {
    return state.machineId
}

export const getLoginProps = state => {
    return {
        user_name: state.login.user_name,
        password: state.login.password,
        machine_id: state.machineId
    }
}

export const getBreadcrumbs = state => {
    return state.breadcrumbs
}

export const getCountryList = state => {
    return state.country_list
}

export const getProvinceList = state => {
    return state.province_list
}

export const getCityList = state => {
    return state.city_list
}

export const getCommunicationVariableList = state => {
    return state.communication_variables
}

export const getMasterModuleList = state => {
    return state.master_module_list
}

export const getFabricWidthList = state => {
    return state.fabric_width_list
}

export const getSalutationList = state => {
    return state.salutation_list
}

export const getUserGroupAlerts = state => {
    return state.user_group_alert
}

export const getUserInformation = state => {
    return state.userInformation
}

export const getAccessRights = state => {
    return state.access_rights
}

export const getUOMMasterList = state => {
    return state.uom_list
}

export const getFabricGSMMasterList = state => {
    return state.fabric_gsm_list
}

export const getDashboardResponse = state => {
    return state.dashboard.response
}

export const getDefaultCountryDetail = state => {
    return state.currency_format
}

export const getMasterQueryList = state => {
    return state.search_query_list
}

export const getTaskCalendar = state => {
    return state.task_calendar_events
}

export const getTaskCalendarEventList = state => {
    return state.task_calendar_event_list
}

export const getSMSCredit = state => {
    return state.sms_credit
}

export const getShipmentCredit = state => {
    return state.shipment_credit
}

export const getEStoreMenuList = state => {
    return state.e_store_menu_list
}

export const getTenantEncryptedKey = state => {
    return state.encrypted_key
}

export const isMobileDevice = state => {
    return isMobile
}

export const getWhatsappLicenseList = state => {
    return state.whatsapp_license_list
}

export const getPaymentList = state => {
    return state.payment_list
}

export const getSubscriptionList = state => {
    return state.subscription_list
}

export const getCouponList = state => {
    return state.coupon_list
}


// WEBPACK FOOTER //
// ./src/store/modules/master/getters.js